import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useTheme } from "../contexts/ThemeContext";
import { getAppUrl } from "../shared-config";

const UserMenu: React.FC = () => {
	const { user, isAuthenticated, login } = useAuth();
	const { theme } = useTheme();

	if (!isAuthenticated || !user) {
		return (
			<button
				onClick={login}
				className={`px-3 sm:px-4 py-2 rounded-lg transition-colors duration-200 ${
					theme === "light"
						? "bg-gray-200 hover:bg-gray-300 text-gray-900"
						: "bg-gray-700 hover:bg-gray-600 text-white"
				}`}
			>
				ログイン
			</button>
		);
	}

	const accountEditUrl = `${getAppUrl("accountApp")}/account-edit`;
	const displayName = user.name
		? `${user.name.lastName} ${user.name.firstName}`
		: user.email;

	return (
		<a
			href={accountEditUrl}
			className={`px-3 sm:px-4 py-2 rounded-lg transition-colors duration-200 inline-block ${
				theme === "light"
					? "hover:bg-gray-200 text-gray-900"
					: "hover:bg-gray-700 text-white"
			}`}
		>
			こんにちは、{displayName}さん
		</a>
	);
};

export default UserMenu;
